import {
  AccountsClient,
  CourseCompletionsClient,
  CourseLocksClient,
  CoursesClient,
  DocumentsClient,
  EmailsClient,
  EventsClient,
  GeneralClient,
  MonitoringClient,
  ReportsClient,
  ScormClient,
  SignupKeysClient,
  PublicationsClient,
  AssignmentsClient,
  SystemConfigurationClient,
  TestcenterClient,
} from "@inctec/elearning-ui-client";
import axios, { type AxiosResponse } from "axios";
import { AuthErrorInterceptor, AuthInterceptor } from "@/services/interceptors";
import {
  HardwareRestrictionsErrorInterceptor,
  HardwareRestrictionsInterceptor,
} from "@/services/hardwareRestrictionInterceptor";

export function initClients() {
  const requestInterceptors = [
    { onFulfilled: HardwareRestrictionsInterceptor, onRejected: () => {} },
    { onFulfilled: AuthInterceptor, onRejected: () => {} },
  ];

  const responseInterceptors = [
    {
      onFulfilled: (response: AxiosResponse) => response,
      onRejected: AuthErrorInterceptor,
    },
    {
      onFulfilled: (response: AxiosResponse) => response,
      onRejected: HardwareRestrictionsErrorInterceptor,
    },
  ];

  ReportsClient.setConfig({
    baseURL: "/services-reporting",
  });

  MonitoringClient.setConfig({
    baseURL: "/services-monitoring",
  });

  DocumentsClient.setConfig({
    baseURL: "/services-documents",
  });

  AccountsClient.setConfig({
    baseURL: "/services-accounts",
  });

  SignupKeysClient.setConfig({
    baseURL: "/services-accounts/api/v2",
  });

  EventsClient.setConfig({
    baseURL: "/services-event",
  });

  CourseCompletionsClient.setConfig({
    baseURL: "/services",
  });

  CourseLocksClient.setConfig({
    baseURL: "/services",
  });

  GeneralClient.setConfig({
    baseURL: "/services",
  });

  CoursesClient.setConfig({
    baseURL: "/services-general",
  });

  PublicationsClient.setConfig({
    baseURL: "/services-general",
  });

  EmailsClient.setConfig({
    baseURL: "/services-email",
  });

  AssignmentsClient.setConfig({
    baseURL: "/services-general",
  });

  ScormClient.setConfig({
    baseURL: "/services-scorm",
  });

  SystemConfigurationClient.setConfig({
    baseURL: "/services-general",
  });

  TestcenterClient.setConfig({
    baseURL: "/services",
  });

  const clients = [
    MonitoringClient,
    DocumentsClient,
    AccountsClient,
    SignupKeysClient,
    ReportsClient,
    EventsClient,
    CourseCompletionsClient,
    CourseLocksClient,
    GeneralClient,
    CoursesClient,
    PublicationsClient,
    EmailsClient,
    AssignmentsClient,
    ScormClient,
    SystemConfigurationClient,
    TestcenterClient,
  ];

  // NOTE: unforuntely axios interceptors have to be added to each instance

  requestInterceptors.forEach(({ onFulfilled, onRejected }) => {
    axios.interceptors.request.use(onFulfilled, onRejected);

    clients.forEach((client) => {
      client.instance.interceptors.request.use(onFulfilled, onRejected);
    });
  });

  responseInterceptors.forEach(({ onFulfilled, onRejected }) => {
    axios.interceptors.response.use(onFulfilled, onRejected);

    clients.forEach((client) => {
      client.instance.interceptors.response.use(onFulfilled, onRejected);
    });
  });
}
